import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { SiteFooter } from "@/components/Brand";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import Listings from "@/pages/Listings";
import ListingForm from "@/pages/ListingForm";
import ListingDetail from "@/pages/ListingDetail";
import Kanban from "@/pages/Kanban";
import Leads from "@/pages/Leads";
import CanvassingMap from "@/pages/CanvassingMap";
import CoBroke from "@/pages/CoBroke";
import { PublicListingPage, PublicCatalogPage } from "@/pages/Public";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

const PublicFooter = () => {
  const { pathname } = useLocation();
  return pathname.startsWith("/app") ? null : <SiteFooter className="bg-[#0A0D14]" />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            classNames: {
              toast: "bg-[#141C2E] border border-white/10 text-slate-100",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/p/listing/:id" element={<PublicListingPage />} />
          <Route path="/catalog/:agentId" element={<PublicCatalogPage />} />

          <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="/app/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/listings" element={<Protected><Listings /></Protected>} />
          <Route path="/app/listings/new" element={<Protected><ListingForm /></Protected>} />
          <Route path="/app/listings/:id" element={<Protected><ListingDetail /></Protected>} />
          <Route path="/app/listings/:id/edit" element={<Protected><ListingForm /></Protected>} />
          <Route path="/app/kanban" element={<Protected><Kanban /></Protected>} />
          <Route path="/app/leads" element={<Protected><Leads /></Protected>} />
          <Route path="/app/map" element={<Protected><CanvassingMap /></Protected>} />
          <Route path="/app/cobroke" element={<Protected><CoBroke /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <PublicFooter />
      </BrowserRouter>
    </AuthProvider>
  );
}
